import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import TransactionAppResource from "./TransactionAppResource";

export const MOXI = '62ecec7a-b2b0-4dce-b3fc-edad0b71dc78';
export const FNF = '01f8f755-9911-444d-828a-b424bd7ed599';
export const SKYSLOPE = '59d81a90-5725-4b56-b80a-ccb508e79955';
export const CINC = '6b38b568-e565-402c-b3c1-9a1628b08e1b';
export const DOTLOOP = 'ba7815b7-508a-4254-a80e-4395b03b4da0';

export const ALL = {
    MOXI,
    FNF,
    SKYSLOPE,
    CINC,
    DOTLOOP,
};

class LuIntegrationTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-integration-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/integration/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            transactions: TransactionAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            }
        };
    }

}

export default LuIntegrationTypeAppResource;
